import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { authStorage } from '../../shared/storage/authStorage'
import axios from 'axios'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
    const [memberInfo, setMemberInfo] = useState(() => authStorage.getMember())

    const signIn = useCallback((member, token) => {
        // Context 与本地缓存同时更新，让路由守卫立即获得最新登录状态。
        // 凭证单独保存，用户资料中不留密码或登录令牌。
        const safeMember = token ? (({ password, loginToken, ...profile }) => profile)(member) : member
        authStorage.setMember(safeMember)
        authStorage.setToken(token)
        setMemberInfo(safeMember)
    }, [])

    const signOut = useCallback(() => {
        // 退出时将当前凭证明确传给后端撤销，避免清理本地缓存后请求拦截器读不到凭证。
        const token = authStorage.getToken()
        axios.post('/api/member/logout', null, {
            headers: token ? { 'X-Auth-Token': token } : {},
        }).catch(() => {})
        authStorage.clearMember()
        authStorage.clearToken()
        setMemberInfo(null)
    }, [])

    const value = useMemo(() => ({
        memberInfo,
        isAuthenticated: Boolean(memberInfo),
        isGuest: memberInfo?.temp === '1',
        signIn,
        signOut,
    }), [memberInfo, signIn, signOut])

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error('useAuth 必须在 AuthProvider 内使用')
    }
    return context
}
